(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const storefront_url = event.currentTarget.dataset.storefrontUrl;
      const sibling_url = event.currentTarget.dataset.siblingUrl;

      if (storefront_url) {
        window.open(storefront_url + window.location.pathname, '_self');
        return;
      }

      if (sibling_url) {
        if (window.location.pathname.includes('/products/')) {
          if (event.currentTarget.hasAttribute('data-is-trade-only'))
            window.open(sibling_url + '/pages/not-found', '_self');
          else {
            window.open(sibling_url + window.location.pathname, '_self');
          }
          return;
        }

        if (window.location.pathname.includes('/blogs/')) {
          window.open(sibling_url + '/blogs/by-the-code', '_self');
          return;
        }

        window.open(sibling_url, '_self');
        return;
      }

      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.mediaQuery = window.matchMedia('(max-width: 750px)');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.mediaQuery.matches) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;      

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class DrawerLocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('#MenuDrawerInputCountryCode, #MenuDrawerInputLocaleCode')
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const storefront_url = event.currentTarget.dataset.storefrontUrl;
      const sibling_url = event.currentTarget.dataset.siblingUrl;

      if (storefront_url) {
        window.open(storefront_url + window.location.pathname, '_self');
        return;
      }

      if (sibling_url) {
        if (window.location.pathname.includes('/products/')) {
          if (event.currentTarget.hasAttribute('data-is-trade-only')) {
            window.open(sibling_url + "/pages/not-found", "_self");
          } else {
            window.open(sibling_url + window.location.pathname, "_self");
          }
          return;
        }

        if (window.location.pathname.includes('/blogs/')) {
          window.open(sibling_url + "/blogs/by-the-code", "_self");
          return;
        }

        window.open(sibling_url, "_self");
        return;
      }

      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('drawer-localization-form', DrawerLocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  class CartAttribute extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('is-ready')) return;

      this.input = this.querySelector('input');
      this.includedCountries = this.dataset.includedCountries.split(',');
      this.excludedCountries = this.dataset.excludedCountries.split(',');
      this.customerCountry = this.dataset.customerCountry;

      this.init();
    }

    init() {
      if (this.dataset.includedCountries == '' && !this.dataset.excludedCountries) {
        // console.log('Default to show to all countries: no included or excluded countries set');
        this.classList.remove('loading');
        this.classList.add('is-ready');
        return;
      }

      if (this.customerCountry && !this.includedCountries.includes(this.customerCountry)) {
        // console.log('Hide: customer country found and does not match an included country');
        this.input.removeAttribute('required');
        this.input.removeAttribute('checked');
        this.classList.remove('loading');
        this.classList.add('hidden');
        return;
      }

      if (this.customerCountry && this.excludedCountries.includes(this.customerCountry)) {
        // console.log('Hide: customer country found and matches an excluded country');
        this.input.removeAttribute('required');
        this.input.removeAttribute('checked');
        this.classList.remove('loading');
        this.classList.add('hidden');
        return;
      }
  
      if (Shopify.designMode) {
        console.log('Show attribute: design Mode On');
      } else {
        const getGeolocation = new Promise((resolve, reject) => {
          if (localStorage.getItem('geoloc')) {
            resolve(JSON.parse(localStorage.getItem('geoloc')));
            return;
          }        
          
          fetch('//api.ipbase.com/v2/info/', { headers: { 'apikey': '425e73a0-4cc3-11ec-8013-3f58ddbf2fe5' }})
            .then(response => response.json())
            .then(responseJson => {
              localStorage.setItem('geoloc', JSON.stringify(responseJson.data));
              resolve(responseJson.data);
              return;
            });
        });

        getGeolocation.then(result => {
          if (!this.includedCountries.includes(result.location.country.alpha2) || this.excludedCountries.includes(result.location.country.alpha2)) {
            // console.log('... Hide: customer country does not match an included country or matches an excluded country');
            this.input.removeAttribute('required');
            this.input.removeAttribute('checked');
            this.classList.remove('loading');
            this.classList.add('hidden');
            return;
          };

          // console.log('... Show: customer country matches an included country or doesnt match an excluded country');
          this.classList.remove('loading');
          this.classList.add('is-ready');
        });
      }
    }

    async getGeolocationData() {
      return await fetch('//api.ipbase.com/v2/info/', { headers: { 'apikey': '425e73a0-4cc3-11ec-8013-3f58ddbf2fe5' }})
        .then(response => response.json())
        .then(responseJson => {
          localStorage.setItem('geoloc', JSON.stringify(responseJson.data));
          return responseJson.data;
        });
    }
  }

  customElements.define('cart-attribute', CartAttribute);

  document.addEventListener('DOMContentLoaded', function() {
    const termsInput = document.querySelector('#CartAttribute_terms-and-conditions');
    const checkoutButton = document.querySelector('.cart__ctas #checkout');
    const checkoutButtonTitle = checkoutButton.getAttribute('title');
    const cartDynamicCheckoutSeparator = document.querySelector('.cart__dynamic-checkout-separator');
    const cartDynamicCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');

    if (!termsInput) {
      return;
    }
    
    if (termsInput.hasAttribute('required')) {
      termsInput.checked?checkoutButton.removeAttribute('disabled'):checkoutButton.setAttribute('disabled', true);
      termsInput.checked?checkoutButton.removeAttribute('title'):checkoutButton.setAttribute('title', checkoutButtonTitle);
      if(cartDynamicCheckoutSeparator) termsInput.checked?cartDynamicCheckoutSeparator.style.display='block':cartDynamicCheckoutSeparator.style.display='none';
      if(cartDynamicCheckoutButtons) termsInput.checked?cartDynamicCheckoutButtons.style.display='block':cartDynamicCheckoutButtons.style.display='none';
      termsInput.addEventListener('click', function() {
        termsInput.checked?checkoutButton.removeAttribute('disabled'):checkoutButton.setAttribute('disabled', true);
        termsInput.checked?checkoutButton.removeAttribute('title'):checkoutButton.setAttribute('title', checkoutButtonTitle);
        if(cartDynamicCheckoutSeparator) termsInput.checked?cartDynamicCheckoutSeparator.style.display='block':cartDynamicCheckoutSeparator.style.display='none';
        if(cartDynamicCheckoutButtons) termsInput.checked?cartDynamicCheckoutButtons.style.display='block':cartDynamicCheckoutButtons.style.display='none';
      })
    } else {
      checkoutButton.removeAttribute('title');
    }

  });

  document.addEventListener('DOMContentLoaded', function() {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function(event) {
      document.querySelector('#cart').submit();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
